module.exports = __webpack_public_path__ + "img/asia06.3fa27358.png";